import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { WebClient } from '@injectables';
import { Client, User } from '@models';
import { op } from '@lib/rxjs';
import { DialogService } from '../dialog.service';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { RestTypes } from '@lib/model-meta';
import { RestModel } from '@lib/web-client/rest-model';

@Component({
  selector: 'app-dialog-add-material-type',
  templateUrl: './dialog-add-material-type.component.html',
  styleUrls: ['./dialog-add-material-type.component.scss']
})
export class DialogAddMaterialTypeComponent {
  public selectedClient:  Client | null = null;
  public materialTypesArray: { text: string; color: string }[] = [];
  public materialType: string = '';
  public restClient: RestModel<Client, RestTypes>;
  public currentInputValue: string = "";
  public readonly selectedClient$ = this.fragQuery.client$;
  public readonly trigger$ = this.fragQuery.trigger$;
  public color: string = '#000000';
  public newMaterialType: string = '';
  private initialMaterialTypes = '[]';

  constructor(
    private readonly fragQuery: FragQueryService,
    private readonly webClient: WebClient,
    public readonly user: User,
    private host: MatDialogRef<boolean>,
    protected readonly dialog: DialogService
  ) {
    this.restClient = this.webClient.model.client;
  }

  private ngOnInit() {
    this.filterClients();
  }

  private filterClients() {
    this.selectedClient$.subscribe((selectedClient) => {
      this.selectedClient = selectedClient;
      this.materialTypesArray = [];
      this.initialMaterialTypes = '[]';
      if (this.selectedClient && this.selectedClient.materialType) {
        const typeAndColour = JSON.parse(this.selectedClient.materialType);
        this.materialTypesArray = typeAndColour ?? [];
        this.initialMaterialTypes = JSON.stringify(this.materialTypesArray);
      }
    });
  }

  public valid() {
    return !!this.selectedClient && (
      this.newMaterialType.trim() !== ''
      || JSON.stringify(this.materialTypesArray) !== this.initialMaterialTypes
    );
  }

  public cancel() {
    this.host.close(false);
  }

  public async save() {
    if (this.newMaterialType.trim() && !this.materialTypesArray.some(item => item.text === this.newMaterialType.trim())) {
      this.materialTypesArray.push({ text: this.newMaterialType.trim(), color: this.color });
    }

    let clientData = this.selectedClient;
    clientData.materialType = JSON.stringify(this.materialTypesArray);
    try {
      await this.dialog.await((async () => {
        await this.restClient.save(clientData);
        this.trigger$.next();
      })());

      this.host.close(true);
    } catch (error) {
      console.error('Save failed', error);
    }
  }

  public addMaterialType(event: any) {
    const input = event.input;
    const value = event.value.trim();
    if (value && !this.materialTypesArray.some(item => item.text === value)) {
      this.materialTypesArray.push({ text: value, color: this.color });
    }
    
    if (input) {
      input.value = '';
    }
  }

  public removeMaterialType(materialType: { text: string; color: string }) {
    const index = this.materialTypesArray.findIndex(item => item.text === materialType.text);
    if (index >= 0) {
      this.materialTypesArray.splice(index, 1);
    }
  }

  public onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.newMaterialType = input.value.trim();

    const existingMaterial = this.materialTypesArray.find(item => item.text === this.newMaterialType);
    if (existingMaterial) {
      this.color = existingMaterial.color;
    }
  }

}
